/**
 * @generated SignedSource<<f0634386559874bd6925655fa37824d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TaskActionEnum = "task_activate" | "task_assign" | "task_copy" | "task_deactivate" | "task_delete" | "task_final_labeling" | "task_first_labeling" | "task_first_labeling_complete" | "task_hint_feedback_publish" | "task_hint_feedback_save" | "task_hint_save" | "task_image_creation_complete" | "task_image_creation_update" | "task_image_request_create" | "task_image_request_delete" | "task_labeling_problem_update" | "task_migrate" | "task_original_update" | "task_problem_creation_complete" | "task_problem_typing" | "task_problem_typing_complete" | "task_problem_update" | "task_publish" | "task_result_feedback_save" | "task_second_labeling" | "task_second_labeling_complete" | "task_solution_video_create" | "task_solution_video_update" | "task_submit_feedback_save" | "task_update" | "task_video_create" | "task_video_update" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TaskActionsMutationButtonStack_task$data = {
  readonly actions: ReadonlyArray<TaskActionEnum>;
  readonly assignedTo: {
    readonly id: string;
  } | null;
  readonly difficulty: number | null;
  readonly finalLabeling: {
    readonly difficulty: number;
    readonly unitDs: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
  readonly id: string;
  readonly inMigrationPairSync: boolean;
  readonly problem: {
    readonly id: string;
    readonly problem: string | null;
    readonly solution: string | null;
  } | null;
  readonly publishedUnitDs: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"TaskHintFeedbackPublishDialog_task" | "TaskMigrateDialog_task" | "TaskMigrationPairSyncDialog_task">;
  readonly " $fragmentType": "TaskActionsMutationButtonStack_task";
};
export type TaskActionsMutationButtonStack_task$key = {
  readonly " $data"?: TaskActionsMutationButtonStack_task$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskActionsMutationButtonStack_task">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "difficulty",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "order": "DESC"
    }
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskActionsMutationButtonStack_task",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "assignedTo",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskHintFeedbackPublishDialog_task"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskMigrateDialog_task"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskMigrationPairSyncDialog_task"
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": (v3/*: any*/),
      "concreteType": "UnitD",
      "kind": "LinkedField",
      "name": "publishedUnitDs",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": "publishedUnitDs(order:{\"order\":\"DESC\"})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskLabeling",
      "kind": "LinkedField",
      "name": "finalLabeling",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": (v3/*: any*/),
          "concreteType": "UnitD",
          "kind": "LinkedField",
          "name": "unitDs",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": "unitDs(order:{\"order\":\"DESC\"})"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inMigrationPairSync",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskProblem",
      "kind": "LinkedField",
      "name": "problem",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "problem",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "solution",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": null
};
})();

(node as any).hash = "de437f6424f1b7854d72e2ef83de7221";

export default node;
